// extracted by mini-css-extract-plugin
export var bodyRow = "_c4-d";
export var cardColumns = "_c4-e";
export var ellipsesOverflow = "_c4-2";
export var flatBottomCorners = "_c4-3";
export var flatTopCorners = "_c4-4";
export var headerActionsDropdown = "_c4-f";
export var headerBottomRow = "_c4-c";
export var headerTopRow = "_c4-b";
export var orderDetailsWrapper = "_c4-0";
export var orderInfoContainer = "_c4-1";
export var productDetails = "_c4-9";
export var productImage = "_c4-5";
export var responsiveTable = "_c4-8";
export var shipmentContainer = "_c4-a";
export var tableBottomLeft = "_c4-6";
export var tableBottomRight = "_c4-7";
export var trackingLink = "_c4-g";